import { render, staticRenderFns } from "./Step3Resumen.vue?vue&type=template&id=3bbf538b&scoped=true&lang=pug"
import script from "./Step3Resumen.vue?vue&type=script&lang=js"
export * from "./Step3Resumen.vue?vue&type=script&lang=js"
import style0 from "./Step3Resumen.vue?vue&type=style&index=0&id=3bbf538b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf538b",
  null
  
)

export default component.exports